import React, { useMemo } from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntDatePicker, LntForm, LntFormItem, LntModalFooter } from '@app/components/base'

import { objectHasNonNullableProp } from '@app/utils/object'

import { BUTTON_TYPE, dateFormat, SIZE } from '@app/constants'

import { formDataConfigs } from './configs'
import { scheduleFormDataAdapter } from './utils'

import styles from './styles.module.scss'

import type { ScheduleChangeFormProps, ScheduleFormData } from './types'

export const ScheduleChangeForm: React.FC<ScheduleChangeFormProps> = ({ onScheduleChange }) => {
  const form = useForm<ScheduleFormData>()

  const isValid = useMemo(() => objectHasNonNullableProp(form.watch()), [form.watch()])

  const handleSubmit = (scheduleFormData: ScheduleFormData): void => {
    const newScheduleData = scheduleFormDataAdapter(scheduleFormData)

    onScheduleChange(newScheduleData)
  }

  return (
    <LntForm
      layout='vertical'
      formInstance={ form }
      onSubmit={ handleSubmit }
    >
      <div className={ styles.scheduleChangeForm__wrapperItems }>
        { formDataConfigs.map(formDataConfig => {
          const { label, name, defaultValue, className } = formDataConfig

          const format = name === 'monitoringStartAtDatetime' ? dateFormat.DD_MM_YYYY : dateFormat.DD_MM_YYYY_HH_mm
          const showTime = name !== 'monitoringStartAtDatetime'

          return (
            <LntFormItem
              key={ `${label}_${name}` }
              label={ label }
              name={ name }
              defaultValue={ defaultValue }
              className={ styles.scheduleChangeForm__item }
            >
              <LntDatePicker
                showTime={ showTime }
                showSecond={ false }
                format={ format }
                className={ styles[className] }
              />
            </LntFormItem>
          )
        }) }
      </div>

      <LntModalFooter>
        <LntButton
          htmlType='submit'
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          disabled={ !isValid }
        >
          Изменить
        </LntButton>
      </LntModalFooter>
    </LntForm>
  )
}
